import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DataTableModule } from "@bfx/primeng/datatable";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { TranslateModule } from "@ngx-translate/core";

import { BfxOrderPauseResumeComponent } from "./bfx-order-pauseresume.component";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { SharedModule } from "@bfx/primeng/api";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    BfxSharedModule,
    TranslateModule,
    FormsModule,
    InputTextModule,
    CheckboxModule,
    PerfectScrollbarModule,
    BaseComponentsModule,
    BfxElementsLibraryModule,
    AgGridModule.withComponents([]),
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  declarations: [BfxOrderPauseResumeComponent],
  exports: [BfxOrderPauseResumeComponent],
  bootstrap: [BfxOrderPauseResumeComponent],
})
export class BfxOrderPauseResumeModule {}
